export default __webpack_public_path__ + "static/HeroGIF-af4a9862b83f50386b7fe88c21052a6c.gif";